/** POS platform locale codes (desktop + menu translations). */
export const PLATFORM_LOCALE_CODES = ["en-US", "zh-CN", "es-MX", "vi-VN"] as const;

/** Receipt second-language codes (printer / order-type bundles). */
export const RECEIPT_SECOND_LANGUAGE_CODES = [
  "zh-Hans",
  "zh-Hant",
  "ja",
  "ko",
  "th",
  "es",
  "fr",
  "de",
  "pt",
  "it",
  "vi",
  "ru",
  "pl",
  "hi",
] as const;

const RECEIPT_TO_PLATFORM: Record<string, string> = {
  en: "en-US",
  "zh-Hans": "zh-CN",
  "zh-Hant": "zh-CN",
  es: "es-MX",
  vi: "vi-VN",
};

const PLATFORM_TO_RECEIPT: Record<string, string> = {
  "en-US": "en",
  "zh-CN": "zh-Hans",
  "es-MX": "es",
  "vi-VN": "vi",
};

/** Maps a receipt second-language code to the matching POS platform locale, when one exists. */
export function receiptSecondLanguageToPlatformLocale(
  receiptCode: string | null | undefined
): string | null {
  if (!receiptCode?.trim()) {
    return null;
  }
  const normalized = receiptCode.trim();
  const direct = RECEIPT_TO_PLATFORM[normalized];
  if (direct) {
    return direct;
  }
  const lower = normalized.toLowerCase();
  return RECEIPT_TO_PLATFORM[lower] ?? null;
}

/** Maps a POS platform locale to the receipt bundle / printer code. */
export function platformLocaleToReceiptSecondLanguage(
  platformCode: string | null | undefined
): string | null {
  if (!platformCode?.trim()) {
    return null;
  }
  return PLATFORM_TO_RECEIPT[platformCode.trim()] ?? null;
}

/** Suggests enabling a POS locale when the user picks a receipt second language. */
export function suggestedPosLocalesForReceiptSecondLanguage(
  receiptCode: string | null | undefined
): string[] {
  const platform = receiptSecondLanguageToPlatformLocale(receiptCode);
  return platform ? [platform] : [];
}
